<template>
<div class="l-app-dashboard">
    <div class="ui relaxed padded grid">
        <div class="computer only tablet only equal width row">
            <div class="column">
                <div class="ui segment">
                    <h4>Commissions Wallet</h4>
                    <h2 class="text-medium text-primary">Ksh. {{walletCommission}}</h2>
                    <div class="ui divider"></div>
                    <button class="ui fluid blue button" disabled>Withdraw</button>
                </div>
            </div>
            <div class="column">
                <div class="ui horizontal segments margin-top-none">
                    <div class="ui segment">
                        <h4>Clients</h4>
                        <h2 class="text-medium text-primary">{{totalclients}}</h2>
                        <div class="ui divider"></div>
                        <button class="ui fluid button" @click="createLeads">Add Client or Lead</button>
                    </div>
                     <div class="ui segment">
                        <h4>Sender IDs</h4>
                        <h2 class="text-medium text-primary">{{totalSenderId}}</h2>
                        <div class="ui divider"></div>
                    </div>
                    <div class="ui segment">
                        <h4>Paybills/Tills</h4>
                        <h2 class="text-medium text-primary">{{totalPaybill}}</h2>
                        <div class="ui divider"></div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="computer only tablet only row">
            <div class="column">
                <h3 class="text-title text-medium">My Clients</h3> <br />
                <div class="actions column">
                <button class="ui large bg-primary button" @click="calculateClientDetails()">Update Sender Ids & Paybill</button>
                </div>
                <table class="ui styled celled table">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Client</th>
                            <th>Contact Details</th>
                            <th class="center aligned collapsing">Sender IDs</th>
                            <th class="center aligned collapsing">Paybills</th>
                            <th class="center aligned">SMS Credits</th>
                            <th class="center aligned">Rate</th>
                            <th class="right aligned">Commission</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(clientsList, index) in clientsLists" :key="clientsList.id">
                            <td class="center aligned collapsing">{{index + 1}}</td>
                            <td>
                                <h4 class="text-medium">{{clientsList.client_name}}</h4>
                                <span class="text-grey">Created: {{clientsList.created_at}}</span>
                            </td>
                            <td><h4>{{clientsList.msisdn}}</h4><small>{{clientsList.client_email}}</small></td>
                            <td class="center aligned">{{clientsList.sender_ids}}</td>
                            <td class="center aligned">{{clientsList.paybills_aggregated}}</td>
                            <td class="center aligned">{{clientsList.balance}}</td>
                            <td class="center aligned">{{clientsList.rates}}</td>
                            <td class="right aligned"><h4 class="text-primary">Ksh. {{clientsList.commision_earned}}</h4></td>
                            <td class="collapsing">
                                <div class="ui icon floating dropdown button">
                                    <i class="dropdown icon"></i>
                                    <div class="menu">
                                        <div class="item" @click="sendMessageClient(clientsList)">Send Message</div>
                                        <div class="item" @click="showAggPaybillTill(clientsList)">Add Paybill/Till</div>
                                        <div class="item" @click="showSenderIDApply(clientsList)">Add Sender ID</div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="computer only tablet only row">
            <div class="column">
                <h3 class="text-title text-medium">My Leads</h3>
                <table class="ui styled celled table">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Client</th>
                            <th>Contact Details</th>
                            <th>Interests</th>
                            <th>Status</th>
                            <th>Next Follow up</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(dsaLead, index) in dsaLeads" :key="dsaLead.lead_id">
                            <td class="center aligned collapsing">{{index+1}}</td>
                            <td>
                                <h4 class="text-medium">{{dsaLead.client_name}}</h4>
                                <span class="text-grey"></span>
                            </td>
                            <td>
                                <h4>{{dsaLead.client_msisdn}}</h4>
                                <small>{{dsaLead.client_msisdn.client_email}}</small>
                            </td>
                            <td>{{dsaLead.interest}}</td>
                            <td>
                                <span class="ui orange label" v-if="dsaLead.status=='1'">Follow up</span>
                                <span class="ui label text-grey" v-if="dsaLead.status=='2'">Uninterested</span>
                                <span class="ui teal label" v-if="dsaLead.status=='3'">Requests Meeting</span>
                                <span class="ui green label" v-if="dsaLead.status=='4'">
                                    <i class="check icon"></i> Converted
                                </span>
                            </td>
                            
                            <td>{{dsaLead.appointment_date}}</td>
                            <td class="collapsing">
                                <div class="ui floating icon dropdown button">
                                    <i class="dropdown icon"></i>
                                    <div class="menu">
                                        <div class="item" @click="moveclient(dsaLead)">Move to client</div>
                                        <div class="item" @click="editClientLeads(dsaLead)">Edit Leads</div>
                                        <div class="item" @click="deleteClientLeads(dsaLead)">Delete Leads</div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <AccountVerify />
        <leadsClients />
        <leadsClientsEdit />
        <leadsClientsDelete />
        <AggPaybillTill />
        <senderIdClient />
        <clientMessage />
    </div>
</div>
</template>

<script>
import clientMessage from "@/modals/client-send-message";
import leadsClients from "@/modals/leadsClients";
import AccountVerify from "@/modals/verifyAgent";
import leadsClientsEdit from "@/modals/leadsClientsEdit";
import leadsClientsDelete from "@/modals/leadsClientsDelete";
import AggPaybillTill from "@/modals/aggregate-paybillClient";
import senderIdClient from  "@/modals/apply-senderIdClient";
import store from "@/store";
import alertify from 'alertifyjs';
export default {
    data() {
        return {
            limit: 5,
            offset: 0,
            dsaLeads:null,
            clientsLists:null,
            totalclients:0,
            totalcommision:0,
            totalSenderId:0,
            totalPaybill:0,
            walletCommission:""
        }
    },
    components: {
        AccountVerify,
        leadsClients,
        leadsClientsEdit,
        leadsClientsDelete,
        AggPaybillTill,
        senderIdClient,
        clientMessage
    },
    
    mounted(){
        let vm = this;
        vm.verifyAccount();
        this.$root.$on('refreshList',(data) => {
            vm.totalclients= [];
            vm.totalclients= 0;
            vm.totalcommision= 0;
            vm.totalSenderId= 0;
            vm.totalPaybill = 0;
            vm.fetchDSALeads();

        });
        //$(".ui.dropdown").dropdown();
    },
   
    methods: {
        verifyAccount(){
            $('.ui.modal#modal-verify-account-agent').modal({
                    closable: false
            }).modal('show');
            
        },
        
        createLeads(){
            $('.ui.modal#modal-contact-leads-clients').modal({
                    closable: false
            }).modal('show');
            
        },
        fetchDSAClient(){
            let vm = this;
            $.post({
                url: store.state.rootURLBulkAPI + "v3/dsa/leads/clients",
                type: "POST",
                data: JSON.stringify({
                    apiKey: this.$cookies.get("key"),
                    offset: vm.offset,
                    limit: vm.limit
                }),
                success: function(response, status, jQxhr) {
                    vm.clientsLists = response.data.data;
                    vm.totalclients = vm.clientsLists[0].total;
                    vm.totalcommision = vm.clientsLists[0].totalCommision;
                    vm.totalSenderId = vm.clientsLists[0].totalSenderId;
                    vm.totalPaybill = vm.clientsLists[0].totalPaybill;
                    vm.walletCommission = response.data.walletCommission;
                    setTimeout(function(){
                        $(".ui.dropdown").dropdown();
                    }, 200)
                },
                error: function(jQxhr, status, error) {
                    vm.loading = false;
                }
            });
        },
        fetchDSALeads(){
            let vm = this;
            $.post({
                url: store.state.rootURLBulkAPI + "v3/dsa/leads/view",
                type: "POST",
                data: JSON.stringify({
                    apiKey: this.$cookies.get("key"),
                    offset: vm.offset,
                    limit: vm.limit
                }),
                success: function(response, status, jQxhr) {
                    vm.dsaLeads = response.data.data;
                    //$(".ui.dropdown").dropdown("refresh");
                },
                error: function(jQxhr, status, error) {
                    vm.loading = false;
                }
            });
        },
        calculateClientDetails(){
            let vm = this;
            $.post({
                url: store.state.rootURLBulkAPI + "v3/dsa/actions",
                type: "POST",
                data: JSON.stringify({
                    apiKey: this.$cookies.get("key"),
                    action: "client_details",
                }),
                success: function(response, status, jQxhr) {
                    alertify.set("notifier", "position", "top-right");
                    alertify.success(response.data.message);
                    
                },
                error: function(jQxhr, status, error) {
                    alertify.set("notifier", "position", "top-right");
                    alertify.error(jQxhr.responseJSON.statusDescription);
                   
                }
            });
        },
        deleteClientLeads(clientDetails){
            
            let vm = this;
            store.commit("setMoveClientDetails",clientDetails);
            $('.ui.modal#modal-contact-leads-clients-delete').modal({
                    closable: false
            }).modal('show');
        },
        editClientLeads(clientDetails){
            let vm = this;
            store.commit("setMoveClientDetails",clientDetails);
            $('.ui.modal#modal-contact-leads-clients-edit').modal({
                    closable: false
            }).modal('show');
        },
        moveclient(clientDetails){
            let vm = this;
            store.commit("setMoveClientDetails",clientDetails);
            $('.ui.modal#modal-contact-leads-clients').modal({
                    closable: false
            }).modal('show');
        },
        showAggPaybillTill(clientDetails) {
            let vm = this;
            store.commit("setMoveClientDetails",clientDetails);
            $('.ui.modal#modal-agg-paybill-till-client').modal({
                centered: false,
                closable: true
            }).modal("show");
        },
        showSenderIDApply(clientDetails) {
            let vm = this;
            store.commit("setMoveClientDetails",clientDetails);
            $('.ui.modal#modal-apply-senderid-client').modal({
                centered: false,
                closable: true
            }).modal("show");
        },
        sendMessageClient(clientDetails) {
            let vm = this;
            store.commit("setMoveClientDetails",clientDetails);
            $('.ui.modal#modal-client-new-message').modal({
                centered: false,
                closable: true
            }).modal("show");
        }
    }
}
</script>
